export default "__VITE_ASSET__CDMCJ0_8__"